import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function SubscriptionError() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "50px" }}>
            <Typography variant="h4" gutterBottom>
                ❌ Error Occurred
            </Typography>
            <Typography variant="body1" paragraph>
                An unexpected error has occurred. Please try again later or contact support.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate("/")}>
                Go to Home
            </Button>
        </Container>
    );
}

export default SubscriptionError;
